var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ChangeDetectorRef } from '@angular/core';
import { ModalService } from '@ibe/services/ui';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { TimeoutSvcService } from '@ibe.services/timeout-svc.service';
import { Router } from '@angular/router';
import { SidebarService } from '@ibe.components/common/sidebar/sidebar.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { INDRAApiService } from '@ibe/services';
import * as ModalActions from '../../../store/actions/modal.actions';
import { Store } from '@ngrx/store';
var INDRAExpirateAlertComponent = /** @class */ (function (_super) {
    __extends(INDRAExpirateAlertComponent, _super);
    function INDRAExpirateAlertComponent(modalService, timeoutSvc, changeRef, router, sidebarService, storageService, apiService, store) {
        var _this = _super.call(this, modalService) || this;
        _this.modalService = modalService;
        _this.timeoutSvc = timeoutSvc;
        _this.changeRef = changeRef;
        _this.router = router;
        _this.sidebarService = sidebarService;
        _this.storageService = storageService;
        _this.apiService = apiService;
        _this.store = store;
        _this.isLoading = false;
        _this.config = {
            template: '$!m!:$!s!',
            leftTime: _this.timeoutSvc.INDRA_getSessionTimeoutTimeRemainingInSeconds() || 60
        };
        _this.TYPE = 'dialog';
        return _this;
    }
    INDRAExpirateAlertComponent.prototype.closeModal = function () {
        this.store.dispatch(new ModalActions.ResetAction());
        this.modalService.close();
    };
    INDRAExpirateAlertComponent.prototype.INDRA_sessionAccept = function () {
        var _this = this;
        this.isLoading = true;
        this.timeoutSvc.sessionRenew().subscribe(function (res) {
            if (res) {
                _this.timeoutSvc.renewLimitReached = res.renewLimitReached;
                _this.isLoading = false;
                _this.timeoutSvc.resetTimer();
                _this.changeRef.markForCheck();
                _this.closeModal();
            }
        }, function (error) {
            _this.isLoading = false;
            _this.timeoutSvc.resetTimer();
            _this.changeRef.markForCheck();
            _this.closeModal();
        });
    };
    INDRAExpirateAlertComponent.prototype.INDRA_sessionCancel = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sessionDeletePromise, err_1, signOutPromise, err_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.storageService.set('allow_navigate', 'true'); // allow redirection to search page with out confirm modal
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.timeoutSvc.sessionDelete().toPromise()];
                    case 2:
                        sessionDeletePromise = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        console.error(err_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.timeoutSvc.resetTimer();
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.apiService.INDRA_signOutFromSession().toPromise()];
                    case 6:
                        signOutPromise = _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        err_2 = _a.sent();
                        console.error(err_2);
                        return [3 /*break*/, 8];
                    case 8:
                        this.changeRef.markForCheck();
                        this.sidebarService.closeSidebar();
                        this.closeModal();
                        if (this.router.url !== '/booking') {
                            setTimeout(function () {
                                _this.router.navigate(['/booking']);
                            }, 500);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    INDRAExpirateAlertComponent.prototype.INDRA_handleCountdownFinish = function () {
        this.INDRA_sessionCancel();
    };
    return INDRAExpirateAlertComponent;
}(AbstractModalContentComponent));
export { INDRAExpirateAlertComponent };
